// extracted by mini-css-extract-plugin
module.exports = {"alGhadeerWrapper":"style_alGhadeerWrapper__Spnff"};